import { UserLogin } from "@/types";
// import UserLogin from "@/utility/User";


import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";

export interface LoginState {
  user: UserLogin
}

@Module({ store, dynamic: true, name: "storeLogin" })
class LoginStore extends VuexModule implements LoginState {

  user = {} as UserLogin

  @Mutation SET_USER_LOGIN(user: UserLogin) {
    this.user = user;
  }

  @Action signIn(data) {
    // console.log('data', data)
    // console.log('user', data['user'])
    // console.log('pass', data['pass'])
    // const dt = DataLogin.getDataLogin(data['user'], data['pass']);
    // dt.then(dt => {
    //   const user = dt.data
    //   console.log('data', user)
    //   this.SET_USER_LOGIN(user)
    // });
  }

}

export const storeLogin = getModule(LoginStore);
